/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "LKEducationAPI",
            "endpoint": "https://960bxbtkcd.execute-api.eu-west-2.amazonaws.com/master",
            "region": "eu-west-2"
        },
        {
            "name": "lionKingEducationCircleofLifeAward",
            "endpoint": "https://sy3hn28431.execute-api.eu-west-2.amazonaws.com/master",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:62c2fcf5-780d-4b3b-961b-1a4a87a10147",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_y5F1F5HVb",
    "aws_user_pools_web_client_id": "738j4k5rupgo93btc1jovm6i3a",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "lkeducations3bucket120646-master",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
